import GUI from "lil-gui";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { demoImage } from "./demoImage";

import {
  backgroundColorSub,
  fovSub,
  rotateSub,
} from "./message/APIProxy.render.server";
import "./server";
import { imageBase64Sub } from "./server/render.server";

// /**
//  * Spector JS
//  */
// const SPECTOR = require('spectorjs')
// const spector = new SPECTOR.Spector()
// spector.displayUI()

/**
 * Base
 */
// Debug
const gui = new GUI({
  width: 200,
});
gui.hide();

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color("#D9D9D9");

// objects group
const product = new THREE.Group();
scene.add(product);

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader();

// Draco loader
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("draco/");

// GLTF loader
const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);

/**
 * Textures
 */
const bakedTexture = textureLoader.load("TRV911-v2.jpg");
bakedTexture.flipY = false;
bakedTexture.colorSpace = THREE.SRGBColorSpace;

/**
 * Materials
 */
// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture });

/**
 * Model
 */
gltfLoader.load("TRV911-v2.glb", (gltf) => {
  console.log("#gltf.scene.children", gltf.scene.children);

  gltf.scene.traverse((child) => {
    // @ts-ignore
    child.material = bakedMaterial;
    console.log(child.name);
    if ("TRV911003" === child.name) {
      child.position.set(0, -0.02, 0);
    }
    if (["TRV911002", "0-TRV911-OLED-096_11002"].includes(child.name)) {
      // child.opacity.set(1);
    } else {
      // child.opacity.set(0.5);
      // child.material.transparent = true;
      // child.material.opacity = 0.1;
      // child.visible = false;
    }
    if (
      [
        "0-TRV911-GLS_52002",
        "GlassCoverbackup",
        // "0-TRV911-BUT_69002",
        // "0-TRV911-ROT7_18002",
      ].includes(child.name)
    ) {
      child.visible = false;
    }
  });

  product.add(gltf.scene);
});

const { screenMaterial } = (function createScreenDisplayPlane() {
  // 4. 定义长方形的尺寸
  const rectangleWidth = 0.012; // 宽度
  const rectangleHeight = rectangleWidth * 2; // 高度 (与宽度不同，形成长方形)

  // 5. 创建长方形平面几何体
  // PlaneGeometry(width, height, widthSegments?, heightSegments?)
  // widthSegments 和 heightSegments 是可选的细分参数，默认为 1x1，对于简单平面足够
  const rectangleGeometry = new THREE.PlaneGeometry(
    rectangleWidth,
    rectangleHeight
  );

  // 6. 创建材质 (这里使用不受光照影响的基础材质)
  // const base64 =
  //   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2SURBVHgB7dSxDQAgDANBmzUZhZpN2DMgsoLLf6U+pbJLepdrKBwgICAgYOe56i/22Vai+IcXjvEGI1cttLoAAAAASUVORK5CYII=";
  const base64 = `data:image/png;base64,${demoImage}`;
  const screenTexture = textureLoader.load(base64, (loadedTexture) => {
    console.log("redTexture loadedTexture", loadedTexture);
  });
  screenTexture.magFilter = THREE.NearestFilter;
  screenTexture.minFilter = THREE.NearestFilter;

  const screenMaterial = new THREE.MeshBasicMaterial({
    color: 0xffffff, // 设置为绿色
    map: screenTexture,
    side: THREE.DoubleSide, // 让平面的两面都可见，默认为 FrontSide
  });
  // @ts-ignore
  screenMaterial.colorSpace = THREE.SRGBColorSpace;
  // 7. 创建网格对象 (Mesh)
  const screenPlaneMesh = new THREE.Mesh(rectangleGeometry, screenMaterial);
  screenPlaneMesh.position.set(0, 0.006, 0.0219);
  product.add(screenPlaneMesh);
  return {
    // screenPlaneMesh,
    // screenTexture,
    screenMaterial,
  };
})();

/**
 * 订阅图片数据变化，更新屏幕显示内容
 */
imageBase64Sub.subscribe((imageBase64) => {
  // 保留对旧纹理的引用，以便稍后释放
  const oldTexture = screenMaterial.map;

  // 使用 textureLoader 加载新图片
  textureLoader.load(
    imageBase64, // data:image/png;base64,...
    // onLoad callback - 新纹理加载完成时执行
    (newTexture) => {
      console.log("New texture loaded successfully");

      // 应用和初始纹理相同的设置
      newTexture.magFilter = THREE.NearestFilter;
      newTexture.minFilter = THREE.NearestFilter;
      // @ts-ignore
      newTexture.colorSpace = THREE.SRGBColorSpace; // 保持颜色空间一致
      newTexture.needsUpdate = true; // 标记纹理数据已更改（有时需要，尤其是在复用纹理对象时）

      // 将新纹理应用到材质
      screenMaterial.map = newTexture;
      screenMaterial.needsUpdate = true; // 告诉 Three.js 材质已经改变，需要更新

      // 释放旧纹理占用的 GPU 资源
      if (oldTexture) {
        oldTexture.dispose();
        console.log("Old texture disposed");
      }
    },
    // onProgress callback (可选)
    undefined,
    // onError callback
    (error) => {
      console.error("Error loading new texture:", error);
    }
  );
});

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  45,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.x = 0;
camera.position.y = 0.05;
camera.position.z = 0.15;
scene.add(camera);

// Controls
// @ts-ignore
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.minDistance = 0.14;
controls.maxDistance = 0.5;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  // @ts-ignore
  canvas: canvas,
  antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();

/**
 * subscribe FOV change
 */
fovSub.subscribe((fov) => {
  camera.fov = fov;
  camera.updateProjectionMatrix();
  controls.update();
});

/**
 * subscribe Rotate change
 */
function rotateProduct(rotateSceneValue: { x: number; y: number; z: number }) {
  const radiansX = rotateSceneValue.x * (Math.PI / 180);
  const radiansY = rotateSceneValue.y * (Math.PI / 180);
  const radiansZ = rotateSceneValue.z * (Math.PI / 180);
  product.rotation.x = radiansX;
  product.rotation.y = radiansY;
  product.rotation.z = radiansZ;
}

rotateSub.subscribe((rotateSceneValue) => {
  rotateProduct(rotateSceneValue);
});

backgroundColorSub.subscribe((color) => {
  scene.background = new THREE.Color(color);
});

/*
// 水平，阀门向左
rotateProduct({ x: 0, y: 0, z: -90 });
// 水平，阀门向右
rotateProduct({ x: 0, y: 0, z: 90 });
// 垂直，阀门向上
rotateProduct({ x: 180, y: 180, z: 0 });
*/
